import React from 'react';
import './dashboard-ux.css';

const STATS = [
  { field: 'total_products',          labelKey: 'overview.total_products',          route: '#/product' },
  { field: 'total_active_products',   labelKey: 'overview.total_active_products',   route: '#/product' },
  { field: 'total_inactive_products', labelKey: 'overview.total_inactive_products', route: '#/product?isActiveOptions=false' },
  { field: 'total_new_products',      labelKey: 'overview.total_new_products',      route: '#/product?new=true' },
];

const DashboardStats = ({ overview = {}, t }) => (
  <div className="dux-stat-strip">
    {STATS.map((s) => (
      <div
        className="dux-stat"
        key={s.field}
        style={s.route ? { cursor: 'pointer' } : undefined}
        onClick={s.route ? () => { window.open(s.route, '_blank', 'noopener'); } : undefined}
      >
        <div className="dux-stat-lab">{t(s.labelKey)}</div>
        <div className="dux-stat-val">{overview[s.field] != null ? overview[s.field] : 0}</div>
      </div>
    ))}
  </div>
);

export default DashboardStats;
